import { For, Show } from "solid-js";
import { A, useLocation } from "@solidjs/router";
import { cn } from "@/utilities/cn";
import Name from "./Name";

export const Breadcrumbs = () => {
  const location = useLocation();

  const getBreadcrumbs = () => {
    const paths = location.pathname.split('/').filter(Boolean);
    return paths.map((path, index) => ({
      text: path,
      url: '/' + paths.slice(0, index + 1).join('/')
    }));
  };

  return (
    <nav class="flex items-center h-14 px-4 w-full">
      <A href='/' class="shrink-0 flex items-center gap-1">
        <span class="text-xl">stuff</span>
        <span class="@[480px]:inline hidden">Home</span>
      </A>

      <Show when={getBreadcrumbs().length > 0}>
        <span class="text-gray-400 mx-2 shrink-0">/</span>
      </Show>

      <div class="flex items-center min-w-0 gap-2">
        <For each={getBreadcrumbs()}>
          {(crumb, index) => (
            <>
              <A
                href={crumb.url}
                class={cn(
                  "hover:underline truncate shrink min-w-0",
                  // index() < getBreadcrumbs().length - 1 && "capitalize"
                )}
                title={crumb.text}
              >
                <Name id={crumb.text} />
              </A>
              <Show when={index() < getBreadcrumbs().length - 1}>
                <span class="text-gray-400 shrink-0">/</span>
              </Show>
            </>
          )}
        </For>
      </div>
    </nav>
  );
};
